module.exports = __webpack_public_path__ + "img/noData.805778d6.png";